import { LockOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Empty, Result, Skeleton } from 'antd';
import type { ReactNode } from 'react';

interface StateProps {
  title?: string;
  description?: string;
  compact?: boolean;
  action?: ReactNode;
}

export function LoadingState({ compact = false }: Pick<StateProps, 'compact'>) {
  return <div className={`feedback-state${compact ? ' feedback-state-compact' : ''}`} aria-busy="true" aria-label="正在載入資料"><Skeleton active paragraph={{ rows: compact ? 3 : 6 }} /></div>;
}

export function EmptyState({ title = '目前沒有資料', description, compact = false, action }: StateProps) {
  return (
    <div className={`feedback-state${compact ? ' feedback-state-compact' : ''}`}>
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<><strong>{title}</strong>{description && <div>{description}</div>}</>}>
        {action}
      </Empty>
    </div>
  );
}

export function ErrorState({ title = '無法載入資料', description = '請稍後再試，若問題持續發生請提供請求識別碼。', compact = false, onRetry }: StateProps & { onRetry?: () => void }) {
  return (
    <div className={`feedback-state${compact ? ' feedback-state-compact' : ''}`}>
      <Result
        status="error"
        title={title}
        subTitle={description}
        extra={onRetry && <Button icon={<ReloadOutlined />} onClick={onRetry}>重新載入</Button>}
      />
    </div>
  );
}

export function PermissionDenied({ description = '你目前的角色沒有檢視或操作此資料的權限。' }: Pick<StateProps, 'description'>) {
  return <div className="feedback-state"><Result icon={<LockOutlined />} status="403" title="權限不足" subTitle={description} /></div>;
}
